import { ArrowDown, Zap } from "lucide-react";
import { BRAND } from "@/lib/brand";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full overflow-hidden bg-grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={BRAND.heroImage}
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/85 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black" />
      </div>

      {/* Vertical accent bar */}
      <div className="absolute left-0 top-1/4 bottom-1/4 w-[2px] bg-yellow-500 hidden md:block" />

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pt-40 pb-24 min-h-screen flex flex-col justify-center">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8 fade-up">
            <span className="h-px w-12 bg-yellow-500" />
            <span className="text-yellow-500 text-xs uppercase tracking-[0.4em]">
              Saint-André · 66690
            </span>
          </div>

          <h1
            className="font-display text-white leading-[0.9] text-6xl sm:text-7xl md:text-8xl lg:text-[9rem] mb-8 fade-up"
            style={{ animationDelay: "0.1s" }}
          >
            LIBÉREZ
            <br />
            <span className="text-yellow-500">LA PUISSANCE</span>
            <br />
            <span className="text-stroke">DE VOTRE</span> MOTEUR.
          </h1>

          <p
            className="text-zinc-300 text-lg md:text-xl max-w-xl mb-10 leading-relaxed fade-up"
            style={{ animationDelay: "0.25s" }}
          >
            Cartographie moteur, cartographie éthanol E85, suppression FAP/EGR,
            préparation moteur. LAD Performance, votre spécialiste tuning dans les Pyrénées-Orientales.
          </p>

          <div
            className="flex flex-wrap items-center gap-4 fade-up"
            style={{ animationDelay: "0.4s" }}
          >
            <a
              href="#contact"
              data-testid="hero-cta-devis"
              className="group inline-flex items-center gap-3 bg-yellow-500 hover:bg-yellow-400 text-black px-8 py-4 font-medium text-sm uppercase tracking-[0.2em] transition-all"
            >
              <Zap className="w-4 h-4" />
              Demander un devis
              <span className="block w-0 group-hover:w-6 h-px bg-black transition-all" />
            </a>
            <a
              href="#services"
              data-testid="hero-cta-services"
              className="inline-flex items-center gap-3 border border-white/20 hover:border-yellow-500 text-white hover:text-yellow-500 px-8 py-4 font-medium text-sm uppercase tracking-[0.2em] transition-all"
            >
              Nos prestations
            </a>
          </div>
        </div>

        {/* Bottom stats / scroll hint */}
        <div className="absolute bottom-10 left-6 md:left-12 right-6 md:right-12 flex items-end justify-between">
          <div className="hidden md:grid grid-cols-3 gap-12">
            {[
              { value: "100%", label: "Fichiers sur mesure" },
              { value: "+30%", label: "Gains moyens en couple" },
              { value: "ALL", label: "Marques acceptées" },
            ].map((s) => (
              <div key={s.label} className="border-l border-yellow-500/60 pl-4">
                <div className="font-display text-3xl text-white">{s.value}</div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-400 mt-1">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
          <a
            href="#services"
            className="hidden lg:flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-zinc-400 hover:text-yellow-500 transition-colors"
            data-testid="hero-scroll-hint"
          >
            Découvrir <ArrowDown className="w-4 h-4 animate-bounce" />
          </a>
        </div>
      </div>

      {/* Marquee */}
      <div className="absolute bottom-0 left-0 right-0 z-20 border-y border-yellow-500/40 bg-black/80 overflow-hidden">
        <div className="flex animate-marquee whitespace-nowrap py-3">
          {Array.from({ length: 2 }).map((_, k) => (
            <div key={k} className="flex items-center gap-12 px-6 shrink-0">
              {[
                "CARTOGRAPHIE MOTEUR",
                "★",
                "CARTOGRAPHIE E85",
                "★",
                "STAGE 1 · 2",
                "★",
                "SUPPRESSION FAP / EGR",
                "★",
                "DIAGNOSTIC MULTIMARQUES",
                "★",
                "PRÉPARATION MOTEUR",
                "★",
                "MÉCANIQUE TOUTES MARQUES",
                "★",
              ].map((t, i) => (
                <span
                  key={`${k}-${i}`}
                  className={`font-display text-sm tracking-[0.25em] ${
                    t === "★" ? "text-yellow-500" : "text-white"
                  }`}
                >
                  {t}
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
